import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import Header from "../../partials/header";
import TypoTitle from "../../partials/typoTitle";
import Snackbar from "../snackbar";
import AddCustomer from "./addCustomer";
import Chart from "./chart";
import ListCustomer from "./listCustomers";
import { styles } from "./styles";

class Customer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddCustomer: false,
      isDetailCustomer: false,
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.addNewCustomer = this.addNewCustomer.bind(this);
    this.statusCreate = this.statusCreate.bind(this);
  }

  handleSearch(event) {
    let value = event.target.value;
    this.setState({ search: value }, function () {
      this.listCustomer.getListCustomer({ search: value });
    });
  }
  addNewCustomer() {
    this.setState({ isAddCustomer: !this.state.isAddCustomer });
  }
  statusCreate(status, message) {
    let { t } = this.props;
    if (status === "01") {
      this.setState({ isAddCustomer: !this.state.isAddCustomer });
      this.mSnackbar.handleClick(t("customer_create_customer_successfully"));
    } else if (status === "02") {
      this.mSnackbar.handleClick(
        t("customer_create_customer_unsuccessfully") + " " + message,
        "error"
      );
    } else if (status === "1109") {
      this.mSnackbar.handleClick(
        t("customer_customer_existed_please_try_again"),
        "error"
      );
    } else {
      this.mSnackbar.handleClick(
        t("customer_upload_image_and_create_customer_unsuccessfully") +
          " " +
          message,
        "error"
      );
    }
  }
  closeAddCustomer = () => {
    this.setState({
      isAddCustomer: false,
    });
  };
  componentDidMount() {
    this.props.customerDispatch.getChart();
  }
  render() {
    const { classes, t, customerState = {} } = this.props;
    const { isAddCustomer, search } = this.state;

    return (
      <div>
        <div>
          <Snackbar
            color="white"
            onRef={(snackbar) => (this.mSnackbar = snackbar)}
          />
          {!isAddCustomer ? (
            <Header
              session={t("sidebar_manage")}
              title={t("customer_list_customers")}
              button={t("customer_add_new_customer")}
              actionButton={this.addNewCustomer}
            />
          ) : (
            <Header
              session={t("customer_list_customers")}
              title={t("customer_add_new_customer")}
              backIcon={true}
              actionBack={() => this.addNewCustomer()}
              colorButton={"default"}
            />
          )}
          {!isAddCustomer ? (
            <ListCustomer
              search={search}
              onRef={(id) => (this.listCustomer = id)}
              listCustomer={customerState.listCustomer}
              addCustomer={this.addNewCustomer}
            />
          ) : (
            <AddCustomer statusCreate={this.statusCreate} />
          )}
          <div className={classes.titleChart}>
            <TypoTitle gutterBottom>{t("customer_chart")}</TypoTitle>
          </div>
          <Chart />
        </div>
      </div>
    );
  }
}

Customer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  customerState: state.customer,
});

const mapDispatch = (dispatch) => ({
  customerDispatch: dispatch.customer,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Customer)));
